
import NavBar from '../../../Components/NavBar'
import NavBarMenu from '../../../Components/NavMenu/comunicacao'
import SpinnerOverlay from '../../../Components/SpinnerOverlay'
import Footer from '../../../Components/Footer'
import { AuthContextApi } from '../../../Context/api'
import { AuthContext } from '../../../Context'
import { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import FolderView from './FolderView';
import AuthorizationModal from './AuthorizationModal';
import FileViewModal from './FileViewModal';

const PastasCompartilhadas = () => {
    const {
        checkLogin,
        getFile,
        getFoldersAuthorizade,
        postFolerAuthorization,
        getFolderAuthorization,
        getPastasCompartilhadas,
    } = useContext(AuthContextApi)
    const { setters, states } = useContext(AuthContext)
    const navigate = useNavigate()
    const { folder_id } = useParams();

    const [selectedFolder, setSelectedFolder] = useState(null);
    const [showFolderView, setShowFolderView] = useState(false);
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [showFileModal, setShowFileModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const authModalStartTime = useRef(null);
    const authModalScroll = useRef(0);

    async function isSigned() {
        const token = Cookies.get('token')
        if (token === null) {
            setters.setSigned(false)
        } else {
            const response = await checkLogin()
            if (response === true) {
                setters.setSigned(true)
            } else {
                Cookies.remove('token')
                setters.setSigned(false)
                navigate('/')
            }
        }
    }

    useEffect(() => {
        isSigned()
        getPastasCompartilhadas();
        return () => {
            setters.setDataPastasCompartilhadas([])
            setters.setPastasCompartilhadas({})
            setters.setFolderAuthorization({})
            setters.setFile({})
            setters.setOffsetPastasCompartilhadas(0)
            setters.setHaveMorePastasCompartilhadas(true)
            setters.setLimitSearchPastasCompartilhadas(false)
        }
    }, [])

    useEffect(() => {
        if (showAuthModal) {
            authModalStartTime.current = Date.now();
            authModalScroll.current = 0;
            // Adiciona listener para calcular scroll_depth
            const onScroll = () => {
                const modal = document.querySelector('.authorization-modal-scroll');
                if (modal) {
                    const scrollTop = modal.scrollTop;
                    const scrollHeight = modal.scrollHeight - modal.clientHeight;
                    const percent = scrollHeight > 0 ? Math.round((scrollTop / scrollHeight) * 100) : 100;
                    if (percent > authModalScroll.current) {
                        authModalScroll.current = percent;
                    }
                }
            };
            setTimeout(() => {
                const modal = document.querySelector('.authorization-modal-scroll');
                if (modal) {
                    modal.addEventListener('scroll', onScroll);
                }
            }, 100);
            return () => {
                const modal = document.querySelector('.authorization-modal-scroll');
                if (modal) {
                    modal.removeEventListener('scroll', onScroll);
                }
            };
        }
    }, [showAuthModal]);

    const handleFolderClick = async (folder) => {
        if (folder.authorization) {
            // setters.setDataPastasCompartilhadas([])
            // setters.setOffsetPastasCompartilhadas(0)
            setSelectedFolder(folder);
            setShowFolderView(true);
            navigate(`/pastasCompartilhadas/${folder.id}`);
        } else {
            await getFolderAuthorization(folder.id);
            setSelectedFolder(folder);
            setShowAuthModal(true);
        }
    };

    const handleAuthorize = async () => {
        const slug = window.location.pathname;
        const duration = Math.round((Date.now() - (authModalStartTime.current || Date.now())) / 1000);
        const scroll_depth = authModalScroll.current || 0;
        const device = navigator.userAgent;
        await postFolerAuthorization({ slug, duration, scrool_depth: scroll_depth, device });
        setShowAuthModal(false);
        getPastasCompartilhadas()
        setShowFolderView(true);
        navigate(`/pastasCompartilhadas/${selectedFolder.id}`);
    };

    const handleOpenFile = async (fileId) => {
        const file = await getFile(fileId);
        setSelectedFile(file);
        setShowFileModal(true);
    };

    const handleCloseFileModal = () => {
        setShowFileModal(false);
        setters.setFile({});
    };

    useEffect(() => {
        if (states.dataPastasCompartilhadas.length > 0) {
            getPastasCompartilhadas()
        }
    }, [states.offsetPastasCompartilhadas])

    // Ajuste: mostrar FolderView se houver folder_id na URL
    useEffect(() => {
        if (folder_id) {
            setShowFolderView(true);
        } else {
            setShowFolderView(false);
        }
    }, [folder_id]);

    // Renderização principal
    return (
        <>
            <div className="flex flex-1 flex-col pb-16 bg-white min-h-screen">
                <NavBar />
                <SpinnerOverlay />
                <div className='flex flex-1 flex-col md:pl-64 mb-4 mt-2'>
                    <div className="p-4">
                        <div className="px-4 sm:px-6 lg:px-8">
                            <h1 className="text-[30px] text-base font-semibold leading-6 text-gray-900">Pastas Compartilhadas </h1>
                        </div>
                        {/* Grid de pastas compartilhadas */}
                        <div className="mt-4 px-4 sm:px-8 lg:px-8">
                            <p className="text-sm text-gray-500">
                                AVISO IMPORTANTE <br />

                                Prezados(as) associados (as),

                                Para garantir a máxima transparência e o acesso às informações de nossa prestação de contas referente ao exercício de 2024, disponibilizamos a seguir, todos os documentos para visualização.

                                É fundamental, no entanto, que todos estejam cientes e respeitem as diretrizes de proteção de dados pessoais, conforme estabelecido na Lei Geral de Proteção de Dados (LGPD), que dispõe sobre o tratamento de dados pessoais, inclusive nos meios digitais. <br />
                                <span className='mt-2' />
                                Por isso, reforçamos que é estritamente proibido baixar, fotografar, tirar print ou compartilhar, por qualquer meio, os documentos aqui apresentados.

                                Os dados sensíveis contidos nestes arquivos foram devidamente tarjados para proteger a privacidade de terceiros. Qualquer tentativa de compartilhamento dos documentos completos, sem as devidas tarjas, configura um ato ilegal e passível de sanções administrativas e judiciais.

                                Agradecemos a compreensão e colaboração de todos na manutenção da segurança e privacidade de nossos dados.

                                DIRETORIA EXECUTIVA DO SINPREV
                            </p>
                        </div>
                        {!showFolderView && (
                            <>
                                <div className="mt-4 bg-gradient-to-r from-blue-500 to-indigo-600 shadow-lg p-6 mb-8 text-white flex items-center gap-4 rounded-xl">
                                    <span className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-white bg-opacity-20">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-white">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12V6.75A2.25 2.25 0 014.5 4.5h3.379c.414 0 .81.17 1.102.474l1.488 1.552c.292.304.688.474 1.102.474H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25H4.5A2.25 2.25 0 012.25 19.5V12z" />
                                        </svg>
                                    </span>
                                    <div className="flex flex-col flex-1 min-w-0">
                                        <span className="text-2xl font-bold text-white truncate">Pastas Compartilhadas</span>
                                        <span className="text-sm text-blue-100 truncate">Acesse aqui as pastas e arquivos compartilhados com você.</span>
                                    </div>
                                </div>
                                <div className="mt-8">
                                    {states.dataPastasCompartilhadas.length === 0 ? (
                                        <div className="text-center text-gray-500">Nenhuma pasta compartilhada encontrada.</div>
                                    ) : (
                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                                            {states.dataPastasCompartilhadas.map(folder => (
                                                <div key={folder.id} className="bg-gradient-to-r from-blue-100 to-indigo-200 rounded-xl shadow-md p-6 flex flex-col justify-between hover:shadow-xl transition cursor-pointer border border-blue-200" onClick={() => handleFolderClick(folder)}>
                                                    <div>
                                                        <h2 className="font-bold text-lg text-gray-800 mb-1 truncate">{folder.name}</h2>
                                                        <p className="text-xs text-gray-500 mb-2">Criada em: {new Date(folder.created_at).toLocaleDateString()}</p>
                                                        <span className={`inline-block px-2 py-1 rounded text-xs font-semibold ${folder.authorization ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>{folder.authorization ? 'Acesso liberado' : 'Acesso restrito'}</span>
                                                    </div>
                                                    <div className="mt-4 flex justify-end">
                                                        {folder.authorization ? (
                                                            <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs font-semibold shadow flex items-center gap-1" onClick={e => { e.stopPropagation(); handleFolderClick(folder); }}>
                                                                Visualizar
                                                            </button>
                                                        ) : (
                                                            <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-xs font-semibold shadow flex items-center gap-1" onClick={e => { e.stopPropagation(); handleFolderClick(folder); }}>
                                                                Solicitar acesso
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {/* Paginação das pastas */}
                                    <div className="flex justify-center mt-8 gap-2">
                                        <button
                                            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50"
                                            disabled={states.offsetPastasCompartilhadas === 0}
                                            onClick={() => setters.setOffsetPastasCompartilhadas(Math.max(0, states.offsetPastasCompartilhadas - states.limitPastasCompartilhadas))}
                                        >Anterior</button>
                                        <button
                                            className="px-4 py-2 rounded bg-blue-500 hover:bg-blue-600 text-white disabled:opacity-50"
                                            disabled={!states.haveMorePastasCompartilhadas}
                                            onClick={() => setters.setOffsetPastasCompartilhadas(states.offsetPastasCompartilhadas + states.limitPastasCompartilhadas)}
                                        >Próxima</button>
                                    </div>
                                </div>
                            </>
                        )}
                        {/* Visualização dos arquivos da pasta */}
                        {showFolderView && (
                            <FolderView onOpenFile={handleOpenFile} onBack={() => {
                                // setShowFolderView(false);
                                // setSelectedFolder(null);
                                // setters.setPastasCompartilhadas({});
                                // setters.setOffsetPastasCompartilhadas(0);
                                navigate(-1);
                            }} />
                        )}
                    </div>
                </div>
                <Footer />
            </div>
            {/* Modal de autorização */}
            <AuthorizationModal
                open={showAuthModal}
                onClose={() => setShowAuthModal(false)}
                authorization={states.folderAuthorization}
                onAuthorize={handleAuthorize}
                scrollClassName="authorization-modal-scroll"
            />
            {/* Modal de visualização segura de arquivo */}
            <FileViewModal
                open={showFileModal}
                onClose={handleCloseFileModal}
                file={selectedFile}
            />
        </>
    );
}

export default PastasCompartilhadas;